import moment from 'moment';
import getLanguageCode from './getLanguageCode';
import getLocale from './getLocale';

export default function getLocalizedDate(date) {
  return moment(date).locale(getLanguageCode(), getLocale[getLanguageCode()]).format('ll');
}
